import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import type { Staff } from "@/lib/authv2/store";

/**
 * Ai mở được màn "Đối soát nhà in" (gói I màn 8): đúng quyền máy chủ gác cả
 * bốn cửa — print.printer_invoice.manage (quản trị, giám đốc, kế toán). Vé chưa
 * mang quyền (chưa đồng bộ) thì menu ẩn thay vì mở ra một trang báo 403.
 */
export function canManagePrinterInvoices(staff: Staff | null | undefined): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.PrintPrinterInvoiceManage);
}
